<template>
  <v-card outlined color="grey lighten-4">
    <v-card-text class="py-2" data-cy="quickFilterBar">
      <v-row>
        <v-col cols="10"
          ><span class="body-2 ml-2"><v-icon class="mr-1" small>fas fa-bolt</v-icon> QUICK FILTERS:</span>
          <quick-filter
            :key="`${quickFilter.label}-${index}`"
            :label="quickFilter.label"
            :quickFilterList="quickFilter.filterList"
            :selectedFilterList="selectedFilterList"
            @addFilterList="addFilterList"
            @removeFilterList="removeFilterList"
            class="ml-2 py-0 px-1"
            v-for="(quickFilter, index) in quickFilterList"
            ><b>{{ quickFilter.label }}</b></quick-filter
          ></v-col
        >
        <v-col class="text-right pr-3" cols="2">
          <quick-filter-manager></quick-filter-manager>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script>
import { mapActions, mapState } from "vuex";

import QuickFilter from "./QuickFilter.vue";
import QuickFilterManager from "./QuickFilterManager.vue";

export default {
  components: { QuickFilter, QuickFilterManager },
  computed: {
    quickFilterList() {
      return [
        ...this.savedQuickFilterList
          .map(quickFilter => {
            const tempQuickFilter =
              quickFilter.presetType === "custom"
                ? this.getCustomPreset(quickFilter.presetName)
                : this.getSystemPreset(quickFilter.presetName);

            if (!tempQuickFilter) return;

            return {
              label: tempQuickFilter.label,
              filterList: tempQuickFilter.filterList,
            };
          })
          .filter(quickFilter => quickFilter),
      ];
    },
    ...mapState({
      customPresetList: state => state.filterPreset.list,
      savedQuickFilterList: state => state.quickFilter.list,
      systemPresetList: state => state.filter.quickFilterList,
    }),
  },
  async created() {
    await this.getQuickFilterList();
  },
  data() {
    return {};
  },
  methods: {
    addFilterList(filterList) {
      this.$emit("addFilterList", filterList);
    },
    getCustomPreset(presetName) {
      const quickFilter = this.customPresetList.find(preset => preset.name === presetName);
      if (!quickFilter) return;
      return {
        filterList: quickFilter.filterList,
        label: quickFilter.name,
      };
    },
    getSystemPreset(presetName) {
      return this.systemPresetList.find(preset => preset.label === presetName);
    },
    removeFilterList(filterList) {
      this.$emit("removeFilterList", filterList);
    },
    ...mapActions({
      getQuickFilterList: "quickFilter/list",
    }),
  },
  props: {
    selectedFilterList: {
      type: Array,
      required: true,
    },
  },
};
</script>

<style></style>
